import { HomeIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { BriefcaseIcon, ChildIcon, FinancialSuccessIcon, RefundIcon, SeniorIcon, TargetIcon } from "Components/_Shared/Icons/Icons";
import { IncomeIncomeType } from "Infrastructure/ApiZfp/Schema";
import type { ReactNode } from "react";

export const INCOME_TYPE_ORDER: IncomeIncomeType[] = [
  IncomeIncomeType.employment,
  IncomeIncomeType.self_employment,
  IncomeIncomeType.rental,
  IncomeIncomeType.parental,
  IncomeIncomeType.pension,
  IncomeIncomeType.disability,
  IncomeIncomeType.orphan_or_widow_pension,
  IncomeIncomeType.other,
];

export const INCOME_TYPE_ICON: Record<IncomeIncomeType, ReactNode> = {
  [IncomeIncomeType.employment]: <BriefcaseIcon />,
  [IncomeIncomeType.self_employment]: <FinancialSuccessIcon />,
  [IncomeIncomeType.rental]: <HomeIcon />,
  [IncomeIncomeType.parental]: <ChildIcon />,
  [IncomeIncomeType.pension]: <SeniorIcon />,
  [IncomeIncomeType.disability]: <SeniorIcon />,
  [IncomeIncomeType.orphan_or_widow_pension]: <RefundIcon />,
  [IncomeIncomeType.other]: <TargetIcon />,
};

/**
 * Maps the API income type onto its key in `Resources.AnalysisDetail.Budget.Incomes.IncomeTypes`.
 * The API values are snake-cased, so they cannot be used as translation keys directly.
 */
export const INCOME_TYPE_TRANSLATION_KEY: Record<
  IncomeIncomeType,
  "Employment" | "SelfEmployment" | "Rental" | "Parental" | "Pension" | "Disability" | "OrphanOrWidowPension" | "Other"
> = {
  [IncomeIncomeType.employment]: "Employment",
  [IncomeIncomeType.self_employment]: "SelfEmployment",
  [IncomeIncomeType.rental]: "Rental",
  [IncomeIncomeType.parental]: "Parental",
  [IncomeIncomeType.pension]: "Pension",
  [IncomeIncomeType.disability]: "Disability",
  [IncomeIncomeType.orphan_or_widow_pension]: "OrphanOrWidowPension",
  [IncomeIncomeType.other]: "Other",
};
